import React from "react";
import Layout from "../../layout";
import FindingTable from "../../components/tables/findings";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { Box, Typography } from "@mui/material";

const AdminAlertsPage = () => {
    return (
        <Layout pageTitle="Security Alerts" parentUrl="" parentPageName="">
            <Grid item xs={6}>
                <Card>
                    <Box sx={{ mt: 0.2, textAlign: "end", backgroundColor: "grey.100" }}>
                        <Typography sx={{ padding: "1rem", fontWeight: 700 }}>
                            Alerts
                        </Typography>
                    </Box>
                    <FindingTable />
                </Card>
            </Grid>
        </Layout>
    );
};

export default AdminAlertsPage;
